import isNil from 'lodash/isNil';
import { LenghtIcon, LimitsRouteIcon } from 'tombac-icons';
import { LimitSummaryContainer, LimitSummaryIcon, LimitSummaryLimit, LimitSummaryUsage } from "./limitSummaryElements";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function KmLimitSummary(_ref) {
  let {
    className,
    limit,
    schema,
    usage
  } = _ref;
  let available = limit === 0 ? 0 : Math.round((limit - usage) / limit * 100);
  if (available < 0) available = 0;
  return !isNil(limit) ? /*#__PURE__*/_jsxs(LimitSummaryContainer, {
    className: className,
    schema: schema,
    children: [schema.unitLabel === 'km route length' ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(LimitSummaryIcon, {
        as: LimitsRouteIcon
      }), ' ', /*#__PURE__*/_jsxs(LimitSummaryLimit, {
        children: [limit, " km route length"]
      }), ' ']
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(LimitSummaryIcon, {
        as: LenghtIcon
      }), ' ', /*#__PURE__*/_jsxs(LimitSummaryLimit, {
        children: [limit, " km"]
      }), ' ']
    }), typeof usage === 'number' && /*#__PURE__*/_jsxs(LimitSummaryUsage, {
      danger: available < 20,
      children: [available, "% available"]
    })]
  }) : null;
}